module.exports = __webpack_public_path__ + "static/kruticka4_orez-ebf3a514995ae04a475f0ee1311c301b.png";